
<div class="flex flex-row items-center laptop:flex-row laptop:items-center laptop:justify-start w-[650px] mb-3">
	<div class="w-[250px]">{{postTitle}}</div>
	<div class="bg-gradient-to-r from-red-500 from-0% via-yellow-500 via-50% to-green-500 to-100% rounded-full h-4 relative w-[300px] mx-[5px]">
		<div class="w-full relative flex flex-row">
			<div class="h-4 absolute top-0 left-0 border-r-2 border-black" style="width: {{percentage}}%"></div>
			<div class="h-4 absolute top-0 left-0 border-l-2 border-black" style="left: {{percentage}}%"></div>
		</div>
	</div>
	<div class="w-[90px]">
		<span class="text-sm font-light {{sentimentColor}}">
		  {{sentimentText}}
		</span>
	</div>
</div>
